// @ts-nocheck
import * as React from 'react';
import $ from 'jquery';

import ImgPending1 from '../images/Img_Pending1.png';
//import ImgPending1 from '../../src/images/Img_Pending1.png';



import ImgWarning1 from '../images/Img_Warning1.png';
import ImgSuccess1 from '../images/Img_Success1.png';

import deletepng from '../images/delete.png';

import DBP0 from '../images/DoorBattPct/0.svg';
import DBP10 from '../images/DoorBattPct/10.svg';
import DBP20 from '../images/DoorBattPct/20.svg';
import DBP30 from '../images/DoorBattPct/30.svg';
import DBP40 from '../images/DoorBattPct/40.svg';
import DBP50 from '../images/DoorBattPct/50.svg';
import DBP60 from '../images/DoorBattPct/60.svg';
import DBP70 from '../images/DoorBattPct/70.svg';
import DBP80 from '../images/DoorBattPct/80.svg';
import DBP90 from '../images/DoorBattPct/90.svg';
import DBP100 from '../images/DoorBattPct/100.svg';

export class CellRenderer extends React.Component {
    constructor(props: any) {
        super(props);
    }

    static CommandValidator(params) {
        
        if (params.value != null && params.value != undefined) {
           
            switch (params.value.toString().trim()) {
                case 'E':
                    return <span className="reefer-alert"><img src={ImgPending1}></img></span>;
                    //imageElement.src = ImgPending1;
                    //break;
                case 'W':
                    return <span className="reefer-alert"><img src={ImgWarning1}></img></span>;
                    //imageElement.src = ImgWarning1;
                    //break;
                default:
                    return <span className="reefer-alert"><img src={ImgSuccess1}></img></span>;
                    //imageElement.src = ImgSuccess1;
                    //break;

            }
        }

        return "-NA-";
    }

    static StringTypeValueFormatter(params) {
        if (params.value != "-NA-") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static StringTypeFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';

    }

    static removeIndicator(params: any) {
        return <span className="reefer-delete"><img src={deletepng} title='Remove' onClick={(e: any) => {
            params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
            params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
        }}></img></span>;
    }

    static deviceFirmwareFormatter(params) {
        var tempRoundingValue = "2";
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            if (params.data.DeviceType != null && params.data.DeviceType.trim() == "CT4000") {
                var tempVal = params.value.split(" ");
                var param = tempVal[1];
                if (param != null && param != undefined) {
                    var val = parseFloat(param.toString());
                    var firmwareRev = tempVal[0] + " " + val.toFixed(parseInt(tempRoundingValue));

                    return <span title={firmwareRev}>{firmwareRev}</span>;
                }
                else
                    return <span title={params.value}>{params.value}</span>;
            }
            else
                return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static battPctFormatter(params) {        
        if (params.data != null && params.data != undefined) {
            if(params.data.AssetType !=null && params.data.AssetType !=undefined && params.data.AssetType !="") {
                if(params.data.AssetType.toUpperCase().trim() == "D") {
                    var doorBattPct: any = params.data.DoorSensorBatteryVoltage;
                    if (doorBattPct != null && doorBattPct != undefined) {
                        var battPct = (Math.round(params.data.DoorSensorBatteryVoltage / 10.0)) * 10;
                
                        switch (battPct){
                            case 0:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP0}></img></span>;
                            case 10:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP10}></img></span>;
                            case 20:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP20}></img></span>;
                            case 30:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP30}></img></span>;
                            case 40:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP40}></img></span>;
                            case 50:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP50}></img></span>;
                            case 60:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP60}></img></span>;
                            case 70:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP70}></img></span>;
                            case 80:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP80}></img></span>;
                            case 90:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP90}></img></span>;
                            case 100:
                                return <span className="pwr_grid_icon" title={doorBattPct}><img src={DBP100}></img></span>;
                        }
                    }
                }
                else {
                    if (params.value == -999)
                        return "-NA-";
                    else {
                        var val = parseFloat(params.value.toString());
                        return val.toFixed(1);
                    }
                }
             }   
            else {
                if (params.value == -999)
                    return "-NA-";
                else {
                    var val = parseFloat(params.value.toString());
                    return val.toFixed(1);
                }
            }
        }
        return '-NA-';
    }
    static DoorBattPctFormatterGrouping(param) {        
        if (param != null && param != undefined) {
            if (param == "-1") return '*No Door bat';
            else {
                switch (param.toString()){
                    case "0":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP0} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "10":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP10} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "20":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP20} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "30":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP30} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "40":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP40} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "50":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP50} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "60":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP60} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "70":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP70} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "80":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP80} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "90":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP90} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "100":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP100} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                }
            }
        }
    }
}